import { z } from 'zod';
/** Politique de mot de passe du portail SEmply. */
export const passwordSchema = z
    .string()
    .min(12, '12 caractères minimum')
    .max(128)
    .regex(/[a-z]/, 'au moins une minuscule')
    .regex(/[A-Z]/, 'au moins une majuscule')
    .regex(/[0-9]/, 'au moins un chiffre');
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email('Adresse e-mail invalide')
    .max(255);
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Mot de passe requis'),
    rememberMe: z.boolean().optional().default(true),
});
export const registerSchema = z.object({
    email: emailSchema,
    password: passwordSchema,
    firstName: z.string().trim().min(1).max(100).optional(),
    lastName: z.string().trim().min(1).max(100).optional(),
    acceptTerms: z.literal(true, { error: 'CGU à accepter' }),
    /**
     * Inscription SUR INVITATION : le compte rejoint l'espace qui l'a invité au
     * lieu d'en recevoir un à lui.
     *
     * Optionnel — la grande majorité des inscriptions n'en portent pas. Mais
     * quand il est là et qu'il ne vaut rien, l'inscription est REFUSÉE plutôt
     * qu'ignorée : quelqu'un qui suit un lien d'invitation expiré doit
     * l'apprendre, pas se retrouver avec un compte solitaire dont il ne
     * comprendra jamais qu'il ne voit rien.
     */
    invitationToken: z.string().min(20).optional(),
});
export const forgotPasswordSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z.object({
    token: z.string().min(20),
    password: passwordSchema,
});
export const verifyEmailSchema = z.object({ token: z.string().min(20) });
export const totpCodeSchema = z.object({
    code: z
        .string()
        .trim()
        .regex(/^[0-9]{6}$/, 'Code à 6 chiffres'),
});
export const recoveryCodeSchema = z.object({
    code: z.string().trim().min(8).max(32),
});
export const updateProfileSchema = z.object({
    firstName: z.string().trim().max(100).nullish(),
    lastName: z.string().trim().max(100).nullish(),
    displayName: z.string().trim().max(150).nullish(),
    locale: z.string().max(10).optional(),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: passwordSchema,
});
/** Second facteur : le mfaToken remis par /auth/login + un code TOTP ou de secours. */
export const mfaChallengeSchema = z
    .object({
    mfaToken: z.string().min(20),
    code: z
        .string()
        .trim()
        .regex(/^[0-9]{6}$/, 'Code à 6 chiffres')
        .optional(),
    recoveryCode: z.string().trim().min(8).max(32).optional(),
})
    .refine((value) => Boolean(value.code) !== Boolean(value.recoveryCode), {
    message: 'Fournir soit un code TOTP, soit un code de secours',
    path: ['code'],
});
/**
 * Confirmation de création de compte via un fournisseur externe (Google,
 * Microsoft, Apple) : les CGU doivent être cochées.
 */
export const socialSignupSchema = z.object({
    acceptTerms: z.literal(true, { error: 'CGU à accepter' }),
});
//# sourceMappingURL=auth.js.map